import {useFormik} from "formik";
import {InputText} from "primereact/inputtext";
import {UserService} from "../services/UserService";
import {Button} from "primereact/button";
import { classNames } from 'primereact/utils';
import {useState, useContext, useEffect} from "react";
import {AuthContext} from "../App";
import {Dropdown} from "primereact/dropdown";
import {MainPageContext} from "./MainPage";

export default function SpotifyUserForm({onSaveUser, newUser, spotifyAppOptions}) {
    const userservice = new UserService();
    const [selectedSpotifyApp, setSelectedSpotifyApp] = useState(null);
    const auth = useContext(AuthContext);
    const mp = useContext(MainPageContext);

    useEffect(() => {
        if(newUser.spotifyapp_id) {
            for(let i=0; i<spotifyAppOptions.length; i++) {
                if(spotifyAppOptions[i].spotifyapp_id === newUser.spotifyapp_id){
                    setSelectedSpotifyApp(spotifyAppOptions[i]);
                    break;
                }
            }
        }
    },[newUser.spotifyapp_id])

    const formik = useFormik({
        initialValues: newUser,
        validate: (data) => {
            let errors = {};

            if (!data.spotify_name) {
                errors.spotify_name = 'Spotify Username is required (can be the same as in spotify, but it is not required).';
            }

            //if (!data.spotify_email) {
            //    errors.spotify_email = 'spotify_email can be a placeholder or hint for you which account is connected to this spotify user.';
            //}

            return errors;
        },
        onSubmit: (data) => {
            if(selectedSpotifyApp !== null) {
                data.spotifyapp_id = selectedSpotifyApp.spotifyapp_id;
            }
            if(data.id){
                let accesstoken = auth.getAccessToken();
                userservice.updateSpotifyUser(data, accesstoken).then((res) => {
                    if(res.status === 200) {
                        res.json().then(data => {
                            onSaveUser(false, data);
                            formik.resetForm();
                            mp.setLastRefreshTime(Date.now());
                            mp.mainToast.current.show({severity: "success", summary: "Updating Spotify User successful", life:3000});
                        })
                    }
                    else
                    {
                        res.json().then(data => {
                            mp.mainToast.current.show({severity: "error", summary: "Error updating Spotify User", detail: data?.detail, sticky: true});
                        })
                        console.error("something went wrong");
                    }
                })
            } else {
                userservice.createSpotifyUser(data, auth.getAccessToken()).then((res) => {
                    if(res.status === 200) {
                        res.json().then(data => {
                            onSaveUser(true, data);
                            formik.resetForm();
                            mp.setLastRefreshTime(Date.now());
                            mp.mainToast.current.show({severity: "success", summary: "Adding Spotify User successful", life:3000});
                        })
                    }
                    else
                    {
                        res.json().then(data => {
                            mp.mainToast.current.show({severity: "error", summary: "Error updating Spotify User", detail: data?.detail, sticky: true});
                        })
                        console.error("something went wrong");
                    }
                })
            }
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const dropDownTemplate = () => {
        if(spotifyAppOptions.length > 0) {
            return(
            <div className="field">
                        <span className="p-float-label">
                            <Dropdown id="spotifyapp_id" name="spotifyapp_id"
                                      value={selectedSpotifyApp} onChange={(e) => setSelectedSpotifyApp(e.value)}
                                      options={spotifyAppOptions} optionLabel="displayname"
                                      />
                            <label htmlFor="spotifyapp_id">Spotify App</label>
                        </span>
                {getFormErrorMessage('spotifyapp_id')}
            </div>)
        } else {
            return <div>No Apps available yet. Create your own? Or ask a friend?</div>
        }
    }

    return(
        <div className="flex justify-content-center">
            <div className="card form-demo">
                <div className="mb-2">
                    <ul className="list-unstyled">
                        <li>Spotify Name is just for you, to distinguish the users in case you create more than one. This name will be shown when selecting where to save playlists.</li>
                        <li>Spotify EMail: You do not have to specify it! But if you do not have your own app, you have to share the spotify account email with the app key provider, e.g. by setting it correctly here.</li>
                        <li>App: If options are shown, select one :) Else you have to create an Spotify App Key first or give someone access. </li>
                    </ul>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid">

                    <div className="field">
                        <span className="p-float-label">
                            <InputText id="spotify_name" name="spotify_name" value={formik.values.spotify_name} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('spotify_name') })} />
                            <label htmlFor="spotify_name" className={classNames({ 'p-error': isFormFieldValid('spotify_name') })}>Name</label>
                        </span>
                        {getFormErrorMessage('spotify_name')}
                    </div>

                    <div className="field">
                        <span className="p-float-label">
                            <InputText id="spotify_email" name="spotify_email" value={formik.values.spotify_email} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('spotify_email') })} />
                            <label htmlFor="spotify_email" className={classNames({ 'p-error': isFormFieldValid('spotify_email') })}>EMail (optional)</label>
                        </span>
                        {getFormErrorMessage('spotify_email')}
                    </div>

                    {dropDownTemplate()}

                    <Button type="submit" label={formik.values.id? "Update" : "Create"} className="mt-2"/>
                </form>
            </div>
        </div>
    )
}